export const DEFAULT_IMAGE_URL = `${window.env.CDN_URL}/assets/default-profile-icon.png`;